/**
 * Deljenje (P2 §3.13) — Web Share, kjer je, sicer odložišče.
 *
 * ⚠️ **Firefox na namizju `navigator.share` nima** in ga po vsej verjetnosti
 * ne bo dobil. Rezerva zato ni prijaznost, ampak pot, po kateri gre vsak
 * drugi uporabnik namizja.
 *
 * ⚠️ **Preklic ni neuspeh.** Uporabnik, ki sistemski list zapre, je pravkar
 * povedal, da ne želi deliti — sporočilo »ni uspelo« bi bilo laž in bi ga
 * poslalo iskat napako, ki je ni. Zato `AbortError` vrne `cancelled`.
 *
 * Deli se **naslov toka**, ne povezava na aplikacijo: prejemnik ga lahko
 * odpre v katerem koli predvajalniku ali prilepi v »dodaj postajo«. Povezava
 * na Nesywave bi zahtevala, da tudi on uporablja Nesywave.
 */

export type ShareOutcome = 'shared' | 'copied' | 'cancelled' | 'failed';

export interface ShareData {
  title: string;
  text: string;
  url: string;
}

export async function shareLink(data: ShareData): Promise<ShareOutcome> {
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share(data);
      return 'shared';
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') return 'cancelled';
      // Vsaka druga zavrnitev (nezavarovan kontekst, manjkajoča gesta, sistem
      // brez cilja) pade na odložišče — poskus je poceni in izid uporaben.
    }
  }

  try {
    await navigator.clipboard?.writeText(data.url);
    return 'copied';
  } catch {
    return 'failed';
  }
}
